export type SwimlaneFilterOption = {
  key: string;
  label: string;
};

/**
 * Ensures selected lane/tier rows remain in the release list even when every
 * card was filtered out. Mirrors the quarterly Roadmap filter effect behavior.
 */
export function ensureEmptySwimlanes(
  releases: any[],
  filterOptions: SwimlaneFilterOption[],
  selectedTypes: string[],
  quarters: Array<{ label: string }>
): any[] {
  const isAllSelected =
    selectedTypes.includes('all') ||
    (selectedTypes.length === filterOptions.length - 1 &&
      !selectedTypes.includes('all'));

  const selectedTypesSet = new Set<string>(
    isAllSelected
      ? filterOptions
          .filter(opt => opt.key !== 'all')
          .map(opt => opt.key as string)
      : selectedTypes
  );

  const selectedLabels = filterOptions
    .filter(opt => selectedTypesSet.has(opt.key as string))
    .map(opt => opt.label)
    .filter(label => label !== 'Key Dates' && !label.includes('Events'));

  const existingLabels = new Set<string>(releases.map((r: any) => r?.type));
  const result = [...releases];

  selectedLabels.forEach(label => {
    if (!existingLabels.has(label)) {
      result.push({
        type: label,
        projects: quarters.map(q => ({ quarter: q.label, project: [] }))
      });
    }
  });

  return result;
}

export function releaseHasVisibleProjects(release: any): boolean {
  return (
    release?.projects?.length > 0 &&
    release.projects.some(
      (project: any) => project?.project && project.project.length > 0
    )
  );
}
